import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Newspaper, Music2, Search, Heart, MoreVertical } from 'lucide-react';

const navPaths = [
  { path: '/', key: 'news', icon: Newspaper },
  { path: '/app', key: 'listen', icon: Music2 },
  { path: '/app/explore', key: 'explore', icon: Search },
  { path: '/app/favorites', key: 'favorites', icon: Heart },
  { path: '/app/settings', key: 'settings', icon: MoreVertical },
];

export const Navigation: React.FC = () => {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50"
      style={{
        // iOS landscape notch + Android nije bitno za horizontalne, ali bezopasno
        paddingLeft: 'env(safe-area-inset-left, 0px)',
        paddingRight: 'env(safe-area-inset-right, 0px)',
      }}
    >
      <div
        className="bg-black/5 backdrop-blur-sm border-t border-white/5"
        style={{
          // Lift tab bar iznad iOS home indicator-a / Android gesture nav bar-a.
          // U browser-u env() je 0 → vizualno isto kao ranije.
          paddingBottom: 'env(safe-area-inset-bottom, 0px)',
        }}
      >
        <div className="flex items-center justify-around py-3 px-2 sm:px-4 max-w-lg mx-auto">
          {navPaths.map((item) => {
            const isActive = location.pathname === item.path;
            const Icon = item.icon;

            return (
              <Link
                key={item.path}
                to={item.path}
                className="flex flex-col items-center gap-1 py-2 px-1 sm:px-4 min-w-0 flex-1"
              >
                <Icon
                  size={24}
                  className={`flex-shrink-0 transition-colors ${
                    isActive ? 'text-white' : 'text-white/70'
                  }`}
                  strokeWidth={isActive ? 2.5 : 2}
                />
                <span
                  className={`text-[10px] sm:text-xs font-medium leading-tight truncate max-w-full transition-colors ${
                    isActive ? 'text-white' : 'text-white/70'
                  }`}
                >
                  {t(`nav.${item.key}`)}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
};
